import { useSalesGetSalesFolks, type ProspectTaskDto } from "@crowdcoursing/api/openapi";
import { skipToken } from "@tanstack/react-query";
import { useMemo } from "react";

import { useSalesBubbleId } from "~hooks/useSalesBubbleId";
import { useSelector } from "~hooks/useTypedRedux";

import { taskAssigneesForBubble } from "./taskAssignees";

export const useTaskAssigneeOptions = (enabled: boolean, current?: ProspectTaskDto) => {
  const salesBubbleId = useSalesBubbleId();
  const currentUser = useSelector((state) => state.user);
  const currentUserId = currentUser?.id;
  const { data: salesFolks = [] } = useSalesGetSalesFolks(enabled ? {} : skipToken);

  const assigneeOptions = useMemo(() => {
    const options = taskAssigneesForBubble(
      salesFolks,
      salesBubbleId,
      current?.assignedToUserId
        ? {
            firstName: current.assignedToFirstName,
            id: current.assignedToUserId,
            lastName: current.assignedToLastName,
          }
        : undefined,
    );
    if (currentUserId && !options.some((option) => option.id === currentUserId)) {
      const label = [currentUser?.firstName, currentUser?.lastName].filter(Boolean).join(" ").trim() || "Me";
      options.unshift({ id: currentUserId, label });
    }
    return options;
  }, [
    current?.assignedToFirstName,
    current?.assignedToLastName,
    current?.assignedToUserId,
    currentUser?.firstName,
    currentUser?.lastName,
    currentUserId,
    salesBubbleId,
    salesFolks,
  ]);

  return { assigneeOptions, currentUserId };
};
